import { S3Bucket } from '@easy-genomics/shared-lib/src/app/types/easy-genomics/s3-bucket';
import { httpClient } from '@/lib/api/client';

class InfraModule {
  async s3Buckets(): Promise<S3Bucket[]> {
    const res = await httpClient.call<S3Bucket[]>('GET', '/list-buckets');

    if (!res) {
      throw new Error('Failed to retrieve S3 Buckets');
    }

    return res;
  }
}

export default InfraModule;
